import { Component, Input, OnInit, OnDestroy, HostBinding, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { BillingService } from '../../../services/billing.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../../utilities/route.utilities';


@Component({
    selector: 'history-bills-grid-item',
    templateUrl: './history-bills-grid-item.component.html',
})
export class HistoryBillsGridItemComponent implements OnInit, OnDestroy {

    subscriptions: any[] = [];
    timePeriod: number = 1;
    clientId: number;
    siteId: number;
    billingHistory: any[] = [];
    hasData: boolean = false;
    hasLoading: boolean = true;

    constructor(
        private billingService: BillingService,
        private route: ActivatedRoute,
        private router: Router) {
        this.subscriptions.push(router.events.subscribe((event) => {

            if (event instanceof NavigationEnd) {
                this.ngOnInit();
            }
        }));
    }

    ngOnInit() {
        this.clientId = getParamFromAncestorRoute(this.route, 'clientId');
        this.timePeriod = getQueryParamFromAncestorRoute(this.route, 'timePeriod');
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getPage(page: number) {
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        queryParams.accountPage = page;

    }

    onInfoClick() {
        swal({
            title: 'Billing history',
            html: '<p style="text-align: left;">This chart shows the total number of bills and total value produced each month.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
